import { assetBaseUrl } from '.';
export const countDownEndDateLF = new Date('2021-06-23T10:00:00+02:00');
export const LFAssetBaseUrl = `${assetBaseUrl}/loubifuture`